module.exports = __webpack_public_path__ + "media/images/navi_ioscor-logo-b309d2a1cf2cf5680bc218ef5e1bbb99.png";